import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShareArrivalTimeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"share_arrival_time"}/>
}
